import firebase from "firebase";

export function deleteImageFromFirebase(oldFileName) {
  const storageRef = firebase.storage().ref();
  const desertRef = storageRef.child(`images/${oldFileName}`);

  desertRef.delete().then(function() {
    console.log("Image delete:", oldFileName)
  }).catch(function(error) {
    console.error("Error image delete:" , error)
  });
}

export function deleteVideoFromFirebase(oldFileName) {
  const storageRef = firebase.storage().ref();
  const desertRef = storageRef.child(`videos/${oldFileName}`);

  desertRef.delete().then(function() {
    console.log("Video delete:", oldFileName)
  }).catch(function(error) {
    console.error("Error video delete:" , error)
  });
}



// WEBPACK FOOTER //
// ./src/services/firebase/storage.js